import { UpcomingMatchesSchema } from './UpcomingMatches.styles';

export const upcomingMatchesStyles: UpcomingMatchesSchema = {
  stackWrapper: {
    px: ['2.5', null, null, '3'],
    pb: '4',
    color: 'white',
  },
  pageHeader: {
    px: '1',
    fontSize: 'md',
    fontStyle: 'normal',
    fontWeight: 'medium',
    fontFamily: 'Roboto',
    lineHeight: 'normal',
    color: 'alpha.700',
    textTransform: 'capitalize',
  },
  boxWrapper: {
    alignItems: 'center',
    display: [null, null, null, 'flex'],
    justifyContent: 'space-between',
  },
  sortByText: {
    fontSize: '2xs',
    fontWeight: 'bold',
    lineHeight: '13.3px',
    textTransform: 'uppercase',
    color: 'gray.700',
  },
  scrollButtonGroup: {
    bg: 'transparent',
    variant: 'filter',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: 'blackAlpha.400',
    borderRadius: 'none',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    pb: '3',
  },
  heading: {
    alignItems: 'center',
    display: 'flex',
    gap: '1.5',
    color: 'brand.700',
    fontSize: 'md',
    fontWeight: 'medium',
    fontFamily: 'Roboto',
    textTransform: 'capitalize',
  },
  headingIcon: {
    color: 'gamma.600',
    sx: {},
  },
  propositionButton: {
    flex: '1',
    height: '35px',
    display: 'initial',
    p: '0',
  },
  flexRenderSortingMobile: {
    justify: 'flex-end',
  },
  mainStackWrapper: {
    spacing: '4',
  },
  mainStackInner: {
    spacing: '4',
  },
  boxSportWrapper: {
    borderColor: 'whiteAlpha.300',
    borderWidth: '1px',
  },
  buttonSport: {
    color: 'white',
    borderColor: 'alpha.300',
    _hover: {
      color: 'gamma.400',
    },
    _active: {
      background: 'yellow.400',
      border: 'none',
      color: 'blackAlpha.700',
      '&:after': {
        display: 'none',
      },
    },
  },
};
